module.exports = __webpack_public_path__ + "img/5.1169a92b.jpg";